export class LoadMore {
	constructor() {
		this.cardsGrid = document.querySelector(".cards-grid") || document.querySelector(".load-more-container");
		this.loadMoreButton = document.querySelector(".cards__load-more-button");
		this.cards = [];
		this.visibleCount = 0;
		this.initialCount = 6;
		this.loadMoreCount = 6;
		this.isLoading = false;
		this.isReducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		).matches;

		if (!this.cardsGrid || !this.loadMoreButton) return;

		this.init();
	}

	init() {
		// Get configuration from data attributes
		this.initialCount = parseInt(this.cardsGrid.dataset.initialCount) || 6;
		this.loadMoreCount = parseInt(this.cardsGrid.dataset.loadMoreCount) || 6;

		// Get all cards
		this.updateCardsList();

		// Set initial visible count
		this.visibleCount = this.initialCount;

		// Hide cards beyond initial count
		this.hideExcessCards();

		// Add event listener
		this.loadMoreButton.addEventListener("click", () => {
			this.loadMoreCards();
		});

		// Update button visibility
		this.updateButtonVisibility();
	}

	updateCardsList() {
		this.cards = [...this.cardsGrid.querySelectorAll(".card")];
	}

	hideExcessCards() {
		// Get cards that are not hidden by filter
		const filteredCards = this.cards.filter(
			(card) => !card.classList.contains("card--hidden")
		);

		// Hide excess filtered cards beyond visible count
		filteredCards.forEach((card, index) => {
			if (index >= this.visibleCount) {
				card.classList.add("card--load-more-hidden");
			} else {
				card.classList.remove("card--load-more-hidden");
			}
		});

		// Make sure all filter-hidden cards don't have load-more-hidden class
		this.cards.forEach((card) => {
			if (card.classList.contains("card--hidden")) {
				card.classList.remove("card--load-more-hidden");
			}
		});
	}

	loadMoreCards() {
		if (this.isLoading) return;

		this.isLoading = true;
		const newVisibleCount = this.visibleCount + this.loadMoreCount;

		// Show next batch of cards with view transition if motion is not reduced
		if (document.startViewTransition && !this.isReducedMotion) {
			// Add view transition name and class to cards that will be shown
			const cardsToShow = this.getCardsToShow(this.visibleCount, newVisibleCount);
			cardsToShow.forEach((card, index) => {
				card.style.viewTransitionName = `load-more-card-${index}`;
				card.style.viewTransitionClass = 'card';
			});

			const transition = document.startViewTransition(() => {
				this.showCards(this.visibleCount, newVisibleCount);
				this.visibleCount = newVisibleCount;
				this.updateButtonVisibility();
				this.isLoading = false;
			});

			// Clean up transition name and class after transition
			transition.finished.then(() => {
				cardsToShow.forEach(card => {
					card.style.viewTransitionName = '';
					card.style.viewTransitionClass = '';
				});
			}).catch(() => {
				// Clean up on error too
				cardsToShow.forEach(card => {
					card.style.viewTransitionName = '';
					card.style.viewTransitionClass = '';
				});
			});
		} else {
			this.showCards(this.visibleCount, newVisibleCount);
			this.visibleCount = newVisibleCount;
			this.updateButtonVisibility();
			this.isLoading = false;
		}
	}

	getCardsToShow(startIndex, endIndex) {
		// Get cards that are not hidden by filter
		const filteredCards = this.cards.filter(
			(card) => !card.classList.contains("card--hidden")
		);

		// Return the cards that will be shown
		return filteredCards.slice(startIndex, endIndex);
	}

	showCards(startIndex, endIndex) {
		// Get cards that are not hidden by filter
		const filteredCards = this.cards.filter(
			(card) => !card.classList.contains("card--hidden")
		);

		// Show the next batch of filtered cards
		filteredCards.slice(startIndex, endIndex).forEach((card) => {
			card.classList.remove("card--load-more-hidden");
		});
	}

	updateButtonVisibility() {
		// Get currently visible (not filter-hidden) cards
		const visibleCards = this.cards.filter(
			(card) => !card.classList.contains("card--hidden")
		);

		if (this.loadMoreButton && this.loadMoreButton.parentElement) {
			// Hide button if all visible cards are shown
			if (this.visibleCount >= visibleCards.length) {
				this.loadMoreButton.parentElement.style.display = "none";
			} else {
				this.loadMoreButton.parentElement.style.display = "block";
			}
		}
	}

	// Called when filter changes
	onFilterChange() {
		// Reset to initial count
		this.visibleCount = this.initialCount;

		// Hide excess cards
		this.hideExcessCards();

		// Update button visibility based on filtered results
		this.updateButtonVisibility();
	}
}
